import { render, staticRenderFns } from "./ImagenComponentSlider.vue?vue&type=template&id=d788455c&"
import script from "./ImagenComponentSlider.vue?vue&type=script&lang=js&"
export * from "./ImagenComponentSlider.vue?vue&type=script&lang=js&"
import style0 from "./ImagenComponentSlider.vue?vue&type=style&index=0&id=d788455c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports